export enum EnumProductsToSell {
  CAJU_BENEFITS = "Caju Benefícios",
  CAJU_EXPENSES = "Caju Despesas",
  CAJU_AWARDS = "Caju premiações",
  CAJU_MAIS = "CajuMais",
  CAJU_CICLOS = "Ciclos",
}